import React from 'react';
import { Alert, Slide, Snackbar } from '@mui/material';

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const Toast = ({ open, onClose, message, messages, severity, duration }) => (
  <Snackbar
    {...{
      open,
      onClose,
      autoHideDuration: duration || 3000,
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
      TransitionComponent: SlideTransition,
    }}
  >
    <Alert {...{ variant: 'filled', severity, onClose }}>
      {message ||
        (messages && messages.map((str) => <p style={{ margin: 0 }}>{str}</p>))}
    </Alert>
  </Snackbar>
);

export default Toast;
